const refueingCharge = () => import ('@/views/refueing/Charge')
const refueingDetail = () => import ('@/views/refueing/Detail')
export default [
    { name:'refueingCharge', path: '/refueing/charge', component: refueingCharge},
    { name:'refueingDetail', path: '/refueing/detail', component: refueingDetail}
]